/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ArchiveTeamBody
 */
export interface ArchiveTeamBody {
  /**
   *
   * @type {string}
   * @memberof ArchiveTeamBody
   */
  teamId: string;
}

/**
 * Check if a given object implements the ArchiveTeamBody interface.
 */
export function instanceOfArchiveTeamBody(
  value: object,
): value is ArchiveTeamBody {
  if (!("teamId" in value) || value["teamId"] === undefined) return false;
  return true;
}

export function ArchiveTeamBodyFromJSON(json: any): ArchiveTeamBody {
  return ArchiveTeamBodyFromJSONTyped(json, false);
}

export function ArchiveTeamBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ArchiveTeamBody {
  if (json == null) {
    return json;
  }
  return {
    teamId: json["teamId"],
  };
}

export function ArchiveTeamBodyToJSON(json: any): ArchiveTeamBody {
  return ArchiveTeamBodyToJSONTyped(json, false);
}

export function ArchiveTeamBodyToJSONTyped(
  value?: ArchiveTeamBody | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamId: value["teamId"],
  };
}
